export default __webpack_public_path__ + "static/media/file.1d7758f5.svg";